import { Component, Input, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-detalles',
  templateUrl: './detalles.component.html',
  styleUrls: ['./detalles.component.scss']
})
export class DetallesComponent implements OnInit {
  @ViewChild('modalFacturar') modalFacturar;
  @Input() detalles: any;
  constructor() { }

  ngOnInit(): void {
  }

  facturar(){
    this.modalFacturar.open();
  }

}
